		//Handle the Mobile Menu

jQuery("document").ready(function()
{		
		
		jQuery(".mobile-menu-button").click(function()
		{
			if (jQuery(this).hasClass('menu-open'))
			{
				jQuery(this).removeClass('menu-open');
				jQuery(".menu-wrapper").removeClass('menu-open');
              jQuery(".store-icons").removeClass("menu-open");
			}
			else
			{
				jQuery(this).addClass('menu-open');
				jQuery(".menu-wrapper").addClass("menu-open");
              	jQuery(".store-icons").addClass("menu-open");
			}
			
		});
});